export default {
    primary: {
        main: "#ffc107",
        light: "#ffca28",
        contrastText: "#333"
    }
}